import React, { ReactNode, useEffect } from "react";
import { tokenRefreshManager } from "data/services/session/TokenRefreshManager";
import { IdleDetector } from "./IdleDetector";
import { InactivityWarningModal } from "./InactivityWarningModal";

export const SessionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  useEffect(() => {
    const initializeSession = async () => {
      await tokenRefreshManager.initialize();
    };

    initializeSession();

    return () => {
      tokenRefreshManager.cleanup();
    };
  }, []);

  return (
    <>
      <IdleDetector />
      <InactivityWarningModal />
      {children}
    </>
  );
};
